import { render, staticRenderFns } from "./Nomenclator.vue?vue&type=template&id=4ee03b5e"
import script from "./Nomenclator.vue?vue&type=script&lang=js"
export * from "./Nomenclator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports